(() => {
  'use strict';
  const root = document.querySelector('.haley-homepage');
  const quiz = root?.querySelector('#quiz');
  const source = root?.querySelector('[data-haley-sales-catalog]');
  if (!quiz || !source) return;
  let catalog;
  try { catalog = JSON.parse(source.textContent); } catch { return; }
  const text = catalog.strings;
  const questions = Array.from(quiz.querySelectorAll('[data-question]'));
  const next = quiz.querySelector('#quiz-next');
  const previous = quiz.querySelector('#quiz-prev');
  const result = quiz.querySelector('[data-result]');
  const sizeSelect = quiz.querySelector('[data-quiz-size]');
  const answers = {};
  let current = 0;
  let started = false;

  function track(event, extra = {}) {
    document.dispatchEvent(new CustomEvent('haley:track', { detail: { event, placement: 'home_quiz', ...extra } }));
  }

  function dimensions(title) {
    const match = String(title).match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)/i);
    return match ? `${Number(match[1])} × ${Number(match[2])} cm` : title;
  }

  const sizes = new Set();
  catalog.products.forEach((product) => product.variants.filter((variant) => variant.available).forEach((variant) => sizes.add(dimensions(variant.title))));
  Array.from(sizes).sort((a, b) => a.localeCompare(b, undefined, { numeric: true })).forEach((size) => {
    sizeSelect.add(new Option(size, size));
  });

  function showQuestion() {
    questions.forEach((question, index) => {
      question.hidden = index !== current;
      question.classList.toggle('active', index === current);
    });
    quiz.querySelectorAll('.hp-quiz__progress-step').forEach((step, index) => {
      step.classList.toggle('active', index === current);
      step.classList.toggle('completed', index < current);
    });
    previous.hidden = current === 0;
    next.disabled = !answers[questions[current].dataset.question];
    next.textContent = current === questions.length - 1 ? text.result : text.next;
  }

  function saveAnswer(question, value) {
    answers[question.dataset.question] = value;
    next.disabled = !value;
    if (!started) { track('quiz_start'); started = true; }
  }

  quiz.querySelectorAll('.hp-quiz__option').forEach((option) => {
    option.addEventListener('click', () => {
      const question = option.closest('[data-question]');
      question.querySelectorAll('.hp-quiz__option').forEach((item) => {
        item.classList.toggle('selected', item === option);
        item.setAttribute('aria-pressed', String(item === option));
      });
      saveAnswer(question, option.dataset.value);
    });
  });
  sizeSelect.addEventListener('change', () => saveAnswer(sizeSelect.closest('[data-question]'), sizeSelect.value));
  previous.addEventListener('click', () => { if (current > 0) { current--; showQuestion(); } });
  next.addEventListener('click', () => {
    if (!answers[questions[current].dataset.question]) return;
    if (current < questions.length - 1) { current++; showQuestion(); } else showResult();
  });

  function node(tag, value, className) {
    const element = document.createElement(tag);
    if (value) element.textContent = value;
    if (className) element.className = className;
    return element;
  }

  function candidates(relaxConstraints = false) {
    const ceiling = answers['4'] === 'budget_low' ? 500000 : answers['4'] === 'budget_mid' ? 800000 : Infinity;
    return catalog.products.map((product) => {
      const variants = product.variants.filter((variant) => variant.available && (relaxConstraints || answers['3'] === 'not_sure' || dimensions(variant.title) === answers['3'])).sort((a, b) => a.price - b.price);
      const variant = variants[0];
      if (!variant || (!relaxConstraints && catalog.currency === 'HKD' && variant.price > ceiling)) return null;
      let score = 0;
      if (answers['1'] === 'firm') score += product.handle === 'haley-purify-mattress' ? 5 : 1;
      if (answers['1'] === 'balanced') score += product.handle === 'hybrid-mattress' ? 5 : product.handle === 'haley-premier-air-pro-mattress' ? 3 : 0;
      if (answers['2'] === 'cooling' && product.handle === 'haley-premier-air-pro-mattress') score += 4;
      if (answers['2'] === 'motion' && product.handle === 'hybrid-mattress') score += 2;
      return { product, variant, score };
    }).filter(Boolean).sort((a, b) => b.score - a.score || a.variant.price - b.variant.price).slice(0, 2);
  }

  // Carry the quiz answers (feel / priority / budget) into WhatsApp so staff don't ask again; skip "not sure".
  function pickedAnswers() {
    return [answers['1'], answers['2'], answers['4']].filter((value) => value && value !== 'not_sure').map((value) => text[value]).filter(Boolean);
  }

  function answerLine() {
    const picked = pickedAnswers();
    return picked.length ? `${text.quiz_answers}${picked.join('／')}` : '';
  }

  // The model pages read this to say "Your top match · Based on your answers: …" (assets/haley-quiz-match.js).
  function saveMatches(matches) {
    try {
      if (!matches.length) {
        localStorage.removeItem('haley_quiz_match');
        return;
      }
      localStorage.setItem('haley_quiz_match', JSON.stringify({
        ts: Date.now(),
        answers: pickedAnswers(),
        matches: matches.map(({ product, variant }, rank) => ({ h: product.handle, v: variant.id, size: dimensions(variant.title), rank }))
      }));
    } catch {}
  }

  function showResult() {
    if (questions.some((question) => !answers[question.dataset.question])) return;
    const matches = candidates();
    saveMatches(matches);
    result.replaceChildren();
    quiz.querySelector('.hp-quiz__body').hidden = true;
    quiz.querySelector('.hp-quiz__footer').hidden = true;
    result.classList.add('active');
    result.style.display = 'block';
    result.append(node('p', text.quiz_note));
    const grid = node('div', '', 'hs-shortlist');
    matches.forEach(({ product, variant }, index) => {
      const card = node('article', '', 'hs-shortlist__card');
      const url = new URL(product.url, window.location.origin);
      url.searchParams.set('variant', variant.id);
      card.append(node('p', index === 0 ? text.quiz_intro : text.alternative, 'hs-eyebrow'), node('h3', product.title));
      card.append(node('p', variant.title), node('strong', variant.priceLabel));
      const key = product.handle === 'hybrid-mattress' ? 'quiz_reason_hybrid' : product.handle === 'haley-purify-mattress' ? 'quiz_reason_purify' : 'quiz_reason_airpro';
      card.append(node('p', text[key]));
      const actions = node('div', '', 'hs-actions');
      const link = node('a', text.view_product, 'hp-btn hp-btn--primary');
      link.href = url.href;
      link.dataset.croEvent = 'quiz_result_click';
      link.dataset.croPlacement = 'home_quiz_result';
      link.dataset.croProduct = product.handle;
      link.dataset.croVariant = variant.id;
      actions.append(link);
      const wa = node('a', text.ask_advisor, 'hp-btn hp-btn--secondary');
      const waUrl = new URL(root.dataset.whatsappUrl);
      waUrl.searchParams.set('text', [text.wa_intro, product.title, `${text.selected_size}：${variant.title}`, variant.priceLabel, answerLine(), url.href, text.source_quiz, text.wa_ask].filter(Boolean).join('\n'));
      wa.href = waUrl.href;
      wa.target = '_blank';
      wa.rel = 'noopener';
      wa.dataset.croEvent = 'whatsapp_click';
      wa.dataset.croPlacement = 'home_quiz_result';
      wa.dataset.croProduct = product.handle;
      wa.dataset.croVariant = variant.id;
      actions.append(wa);
      card.append(actions);
      grid.append(card);
    });
    if (!matches.length) {
      grid.append(node('p', text.no_match));
      const wa = node('a', text.ask_advisor, 'hp-btn hp-btn--secondary');
      const url = new URL(root.dataset.whatsappUrl);
      const models = candidates(true).map(({ product }) => product.title).filter(Boolean);
      const modelNames = models.length ? models.join(' / ') : catalog.products.map((product) => product.title).filter(Boolean).join(' / ');
      url.searchParams.set('text', [text.wa_no_match_intro, `${text.selected_size}：${answers['3'] === 'not_sure' ? text.not_sure : answers['3']}`, answerLine(), `${text.wa_models}${modelNames || 'Haley'}`, text.source_quiz, text.wa_ask].filter(Boolean).join('\n'));
      wa.href = url.href;
      wa.target = '_blank';
      wa.rel = 'noopener';
      wa.dataset.croEvent = 'whatsapp_click';
      wa.dataset.croPlacement = 'home_quiz_no_match';
      grid.append(wa);
    }
    result.append(grid);
    const restart = node('button', text.restart, 'hp-quiz__restart-btn');
    restart.type = 'button';
    restart.addEventListener('click', () => {
      current = 0;
      Object.keys(answers).forEach((key) => delete answers[key]);
      quiz.querySelectorAll('.hp-quiz__option').forEach((option) => { option.classList.remove('selected'); option.setAttribute('aria-pressed', 'false'); });
      sizeSelect.value = '';
      quiz.querySelector('.hp-quiz__body').hidden = false;
      quiz.querySelector('.hp-quiz__footer').hidden = false;
      result.classList.remove('active');
      result.style.display = 'none';
      showQuestion();
    });
    result.append(restart);
    result.focus({ preventScroll: true });
    track('quiz_complete', { product: matches[0]?.product.handle || 'no_match' });
  }
  showQuestion();
})();
